import { type ReactNode } from 'react';

import { Map } from '@/microfrontends/map/shared';

import { MapBanners } from '@/packages/MapBanners';
import { useGetClustersQuery } from '@/packages/query-state/shared/store/search-offers-index/v2/get-clusters-for-map/query';
import { useFiltersSelector } from '@/packages/redux-state/store/slices/jsonQuery';
import { useUserIsAgentSelector } from '@/packages/redux-state/store/slices/user';

import { useApplicationContext } from '../../context/ApplicationContext';
import { useElementsRefContext } from '../../context/ElementsRefContext';

import { MapLayout } from './internal/components/MapLayout';
import { useCalculateMapSizes } from './internal/hooks/useCalculateMapSizes';

export function MapLayoutContainer(): ReactNode {
  const context = useApplicationContext();

  const { mapContainerRef } = useElementsRefContext();

  const isAgent = useUserIsAgentSelector();

  const jsonQuery = useFiltersSelector();

  const { isFetching } = useGetClustersQuery();

  useCalculateMapSizes();

  return (
    <MapLayout
      banners={<MapBanners jsonQuery={jsonQuery} userIsAgent={isAgent} />}
      disabled={isFetching}
      map={<Map context={context} />}
      ref={mapContainerRef}
    />
  );
}
